import ActionModal from "components/Settings/components/ActionModal";
import SuccessImage from "assets/images/svg/feedback-success.svg";

function ReviewSubmitModal({ open, setOpen }) {
  return (
    <ActionModal open={open} width={804} setOpen={setOpen}>
      <div className="flex flex-col items-center gap-2 review-submit-content">
        <span className="">
          <img src={SuccessImage} alt="image" />
        </span>
        <span className="font-title-xl leading-5 text-center content-title">
          Thank you for your feedback!
        </span>
        <p className="font-title-sm leading-4 text-center">
          Your response has been submitted successfully. We appreciate your time
          and effort in helping us improve.
        </p>
      </div>
    </ActionModal>
  );
}

export default ReviewSubmitModal;
